export default {
  props:['id','logs'],

  data(){
    return {
      data:[]
    }
  },
  created(){

    this.$watch('id' , function(nv){
      if( nv ){
        this.query()
      }
    },{immediate:true})


    this.$watch('logs' , function(nv){
      if( nv ){
        this.data = this.$utils.conv(nv , {'createDatetime':'datetime','actType':'licenseLogType'})
      }
    },{immediate:true})
  },
  methods:{
    query(){
      this.$request.licenseViolationLog(this.id).then( resp => {
        if(resp.code == 0){
          this.data = this.$utils.conv(resp.data , {'createDatetime':'datetime','actType':'licenseLogType'})
        }else{
          this.$Message.error({ content: resp.msg })
        }
      })
    }
  },
  render(){
    const data = this.data || []
    return (
      <Timeline style="padding:24px;">
        {
          this.data.map( i => (
            <TimelineItem>
              <div style="margin-bottom:8px;font-size: 13px; color: rgba(0, 0, 0, 0.85);">
                <p>{i.userName} {i.actTypeText}</p>
                {
                  i.actType == 2 ? <p style="margin-top:8px;font-size:12px;color:rgba(0,0,0,.65);">结果：{i.actDesc}</p> : null
                }
              </div>
              <p style="font-size: 10px;font-weight: bold;color:rgba(0,0,0,.45);">{i.createDatetimeText}</p>

            </TimelineItem>
          ))
        }
      </Timeline>
    )
  }
}